export default {
  personalDetails: 'Personal details',
  workExperience: 'Work experience',
  preference: 'Preference',
  viewFile: 'Your uploaded file',
  jobProfile: 'Job Profile',
  fields: {
    name: 'Full Name *',
    gender: 'What is your gender? *',
    qualification: 'What is your highest qualification? *',
    specialisation: 'What is your specialisation?',
    resume: 'Do you have a resume?',
    experience: 'How long were you working *',
    pastEmployer: 'Your past employer?',
    designation: 'Your recent designation?',
    salary: 'Your recent salary?',
    jobCategory: 'What kind of job are you looking for *',
    preferredLocation: 'Your preferred location? *',
    jobType: 'Your preferred job type *',
    workType: 'Your preferred work type *',
    shiftTiming: 'Your preferred work time *'
  },
  uploadResume: 'Upload your resume',
  uploadText: 'You can upload a .jpg, .pdf or a word doc. OR take a picture',
  optional: 'Optional',
  placeholders: {
    name: 'Provide your full name for recruiters',
    specialisation: 'eg: Engineering, Arts',
    pastEmployer: 'eg: TCS, Wipro',
    designation: 'eg: Sales Manager',
    salary: 'Choose a salary range',
    jobCategory: 'Choose job categories',
    preferredLocation: 'Select multiple districts',
    searchForJobs: 'Search for jobs',
    signUp: 'Signup'
  },
  buttons: {
    uploadResume: 'Upload resume',
    capture: 'Take a picture',
    uploadFromDevice: 'Upload from device',
    next: 'Next',
    submit: 'Submit',
    done: 'Done',
    viewFile: 'View File',
    delete: 'Delete',
    change: 'Change',
    pause: 'Pause',
    retry: 'Retry'
  },
  allStates: 'Anywhere in {state}',
  jobCategory: 'Job Category',
  preferredLocation: 'Preferred Location',
  salary: 'Choose Salary Range',
  resume: 'Resume',
  recommendedJobs: 'Recommended jobs',
  sponsoredJobs: 'Sponsored jobs',
  footerFields: {
    CustomerServices: 'Customer Services',
    emailUs: 'Email us',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and conditions',
    needJob: 'Need a job near you?',
    jobs: '1 lakh jobs',
    sections: '40 sections'
  },
  emptyResultsScreenFields: {
    jobsByCategories: 'Jobs by Categories',
    jobsByLocation: 'Jobs by Location',
    headerMessage1: 'Sorry, we could not find any open roles for your search',
    headerMessage2: 'Signup for Job alerts and we’ll notify you when new jobs have opened up',
    explore: 'Explore jobs by categories and location',
    noOfJobs: '10 jobs',
    icon: 'icon'
  },
  exploreJobsFiltersFields: {
    Category: 'Category',
    salaryRange: 'Salary Range',
    Experience: 'Experience',
    exploreJobsHero: 'Explore by job categories'
  },
  faqFields: {
    header: 'Frequently asked questions'
  },
  homePageHeroFields: {
    findDreamJob: 'Find your dream job!',
    availableJobsAndNoOfCities: ' 50 Lakh+ Jobs | 70+ Cities',
    content: 'Apply for jobs on Lokalapp & talk to the HRs of the companies directly.'
  },
  appalyForJob: 'Apply for a Job',
  searchJob: 'Search job',
  postAJob: 'Post A job',
  jobFindingStepsFields: {
    step1: '1. Create your job Profile',
    step2: '2. Find a job vacancy',
    step3: '3. Contact the HR directly to Apply',
    hero: 'Find your dream job using Lokal in 3 simple steps:'
  },
  jobSearchPlaceHolder: 'Search for jobs',
  share: 'Share',
  shareOnWhatsApp: 'Share on WhatsApp',
  report: 'Report',
  viewJobs: 'View jobs',
  lookingForJobHero: {
    hero: 'Looking for a job?',
    content: 'The sky was cloudless and had a deep blue hue.'
  },
  postNewJobFields: {
    hero: 'Post your work Local application in 3 simple steps:',
    content1: 'Target job advertising from 250+ districts',
    content2: 'Recruit from 1 lakh eligible candidates',
    content3: 'Get maximum responses at low rates'
  },
  quickAccessFooterFields: {
    quickLinks: 'Quick Links',
    categoryWiseJobs: 'Category wise jobs',
    jobsByLocation: 'Jobs by location',
    viewAllCategories: 'View all categories',
    viewAllLocations: 'View all locations'
  },
  jobSearchPlaceHolder1: 'Enter Job title, keyword,...',
  warangal: 'warangal',
  krishna: 'krishna',
  vishakapatnam: 'Vishakapatnam',
  yadadri: 'yadadri',
  guntur: 'guntur',
  jobs: 'Jobs',
  seeAll: 'See all',
  jobListing: 'Job Listing',
  findAJob: 'Find a job',
  createAnAccount: 'Create an account',
  jobSearchAdvice: 'Job Search Advice',
  administration: 'Administration',
  digitalMarketing: 'Digital Marketing',
  design: 'Design',
  development: 'Development',
  productmanagement: 'Product management',
  finance: 'Finance',
  agra: 'Agra',
  bengaluru: 'Bengaluru',
  delhi: 'Delhi',
  mumbai: 'Mumbai',
  hi: 'Hi',
  home: 'Home',
  exploreJobs: 'Explore Jobs',
  postAJob: 'Post a Job',
  contactUs: 'Contact Us',
  contact: 'contact',
  getTheApp: 'Get the App',
  loginOrCreateAnAccount: 'Login or Create an account',
  login: 'Login',
  createYourProfile: 'Create profile',
  editProfile: 'Edit Profile',
  myProfile: 'My Profile',
  logOut: 'Log Out',
  disclosureTitle: {
    jobDetails: 'Job Details',
    feesRequired: 'Fees Required',
    noFeeIsRequired: 'No fee is required'
  },
  whyIsItNeeded: 'Why is it needed',
  emailUsOn: 'email us on',
  similarJobs: 'Similar Jobs',
  noSimilarJobs: 'No similar Jobs',
  loading: 'Loading',
  enterNewMobileNumber: 'Enter new mobile number',
  mobileNumber: 'Mobile Number',
  anOtpWillBeSentToThisNumber: 'An OTP will be sent to this number',
  welcomeToLokal: 'Welcome to Lokal',
  loginOrSignup: 'Login or Signup',
  otpDiscription:
    'Enter the mobile number you wish to be contacted on. An OTP will be sent to this number',
  iAgreeToThe: 'I agree to the',
  and: 'and',
  yesApply: 'Yes,apply',
  termsAndConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
  continue: 'Continue',
  checkYourSms: 'Check your SMS',
  weHaveSentYouAnOtpOn: 'We have sent you an OTP on',
  changeNumber: 'Change Number',
  enterFourDigitOtp: 'Enter 4 digit OTP',
  didNotRecieveTheOtp: 'Did not receive the OTP',
  otpCheckBoxDiscription: 'I would like to receive WhatsApp notifications',
  done: 'Done',
  incorrectCredentials: 'Incorrect credentials',
  resendOtp: 'Resend OTP',
  resendOtpIn: 'Resend OTP in',
  noResultsFoundFor: 'No results found for',
  jobsTitle: 'Jobs in {location} | Find Job Vacancies in {location} : {host}/jobs',
  jobsMetaData:
    'Apply for Jobs in {location} on {host}/jobs. Register for Free & Find Job Openings in {location}',
  posted: 'Posted',
  ago: 'ago',
  views: 'views',
  cancel: ' cancel',
  pleaseTryAgain: 'Please try again',
  locationsNotAvailable: 'Locations not available',
  jobsByCategories: 'Jobs by category',
  footerModelForApplyJobFields: {
    header1: 'Are you sure want to continue',
    header2: 'Job Application has been succesfully Submitted',
    applyConformation: 'applying for this job?',
    subText1: 'if selected,you will receive a call from the recuiter',
    subText2: 'Your details will be sent to the recruiter'
  },
  advertiser: {
    whatOurUsersSay: 'What our employers have to say about Lokal'
  },
  searchJobs: 'Search Jobs',
  createFreeAccount: 'Create free account',
  jobAdvice: 'Job Advice',
  postAJob: 'Post a Job',
  mobileNumber: 'Mobile Number',
  sendOTP: 'Send OTP',
  verifyOTP: 'Verify OTP',
  downLoadApp: 'Download the app',
  jobsNearMeTitle: '{numberOfJobs} Job Openings & Vacancies  - Find the Perfect Job',
  jobsDescription:
    'Searching for jobs in {Location}? Find the latest openings and vacancies in {Location} in 2023 with Lokal Job Listings',
  postJobSteps: {
    jobDetail: 'வேலை விவரம்',
    aboutJob: 'வேலை பற்றி',
    selectRole: 'வேலை பாத்திரத்தை தேர்ந்தெடு',
    selectTitle: 'வேலை பெயரை தேர்ந்தெடுங்கள்',
    postTitle: 'இடுகை தலைப்பை உள்ளிடவும்',
    sampleJobTypes: 'உதாரணம். விற்பனை கணக்காளர், டெலிவரி பாய் போன்றவை',
    addJobDescription: 'வேலை விளக்கத்தைச் சேர்க்கவும்',
    removeJobDescription: 'வேலை விளக்கத்தை அகற்று',
    NoOfOpenings: 'திறப்புகளின் எண்ணிக்கை',
    enterNoOfOpenings: 'திறப்புகளின் எண்ணிக்கையை உள்ளிடவும்',
    monthlyIncome: 'மாதாந்த வருமானம்',
    enterMinSalary: 'குறைந்தபட்ச சம்பளத்தை உள்ளிடவும்',
    enterMaxSalary: 'அதிகபட்ச சம்பளத்தை உள்ளிடவும்',
    jobShift: 'வேலை மாற்றம்',
    dayShift: 'பகல் ஷிப்ட்',
    nightShift: 'இரவு ஷிப்ட்',
    anyShift: 'ஏதேனும் மாற்றம்',
    jobType: 'வேலை வகை',
    fieldJob: 'தாக்கல் செய்யப்பட்ட வேலை',
    officeJob: 'அலுவலக வேலை',
    workFromHome: 'வீட்டிலிருந்து வேலை',
    industryJob: 'தொழில்துறை வேலை',
    officeLocation: 'அலுவலக இடம்',
    interstedPlace: 'நீங்கள் எங்கிருந்து பணியமர்த்த ஆர்வமாக இருக்கிறீர்கள்?',
    district: 'மாவட்டம்',
    selectMultipleDistricts: 'பல மாவட்டங்களைத் தேர்ந்தெடுக்கவும்',
    charges: 'இந்த வேலைக்கு, விண்ணப்பதாரர்களிடமிருந்து ஏதேனும் கட்டணம் வசூலிக்கப்படுமா',
    yes: 'ஆம்',
    no: 'இல்லை',
    reasonForFee:
      'தயவுசெய்து உண்மையான காரணங்களுக்காக கட்டணம் வசூலிக்கப்படுவதை உறுதிசெய்து, கட்டணத்திற்கான காரணத்தை வேட்பாளருக்கு தெளிவாக தெரிவிக்கவும்',
    feeAmount: 'கட்டணத் தொகை (ரூபாயில்)',
    selectReasonsForFee: 'கட்டணத்திற்கான காரணங்களைத் தேர்ந்தெடுக்கவும்',
    registrationFee: 'பதிவுக் கட்டணம்',
    trainingFee: 'பயிற்சி கட்டணம்',
    feeForOtherReasons: 'சீருடைகள், உபகரணங்கள், கருவிகள் போன்றவற்றிற்கான கட்டணம்.',
    securityDeposit: 'பாதுகாப்பு வைப்பு',
    commission: 'தரகு',
    otherReason: 'வேறு காரணம்',
    specifyOtherReason: 'வேறு காரணத்தை குறிப்பிடவும் (ஏதேனும் இருந்தால்)',
    feeDueDate: 'கட்டணம் எப்போது செலுத்தப்பட வேண்டும்',
    afterGivingJob: 'வேலை கொடுத்த பிறகு',
    beforeGivingJob: 'வேலை கொடுப்பதற்கு முன்',
    candidateRequirement: 'வேட்பாளர் தேவை',
    candidateQualification: 'வேட்பாளர் தகுதி',
    selectMinimumEducation: 'குறைந்தபட்ச கல்வியை தேர்ந்தெடு',
    selectYourExperience: 'அனுபவத்தைத் தேர்ந்தெடுக்கவும்',
    preferredGender: 'விருப்பமான பாலினம்',
    male: 'ஆண்',
    female: 'பெண்',
    anyGender: 'எந்த பாலினமும்',
    contactCandidatesThrough: 'இதன் மூலம் வேட்பாளர்களை நிர்வகிக்கவும்',
    callOnWhatsapp: 'அழைப்புகள் மற்றும் வாட்ஸ்அப்',
    callOnly: 'அழைப்புகள் மட்டுமே',
    whatsappNo: 'வாட்ஸ்அப்பின் அதே எண்',
    next: 'அடுத்த',
    companyDetail: 'நிறுவனத்தின் விவரம்',
    selectCompanyType: 'உங்கள் நிறுவன வகையைத் தேர்ந்தெடுக்கவும்',
    consultancy: 'ஆலோசனை / மனிதவள நிறுவனம்',
    hiresThirdPartyCompany: 'நான் மூன்றாம் தரப்பு நிறுவனங்களுக்கு பணியமர்த்துகிறேன்',
    company: 'நிறுவனம்',
    hireForMyComapny: 'நான் எனது நிறுவனம் / கடைக்கு வாடகைக்கு அமர்த்துகிறேன்',
    company: 'நிறுவனம்',
    companyname: 'நிறுவனத்தின் பெயரை உள்ளிடவும்',
    companySize: 'நிறுவனத்தின் அளவு',
    largeScale: 'பெரிய அளவிலான [50+ ஊழியர்கள்]',
    midScale: 'நடுத்தர அளவு [20-50 ஊழியர்கள்]',
    smallScale: 'சிறிய அளவிலான [5-20 ஊழியர்கள்]',
    companyNameToBeDisplayed: 'இந்த வேலைக்கான விண்ணப்பதாரர்களுக்கு நிறுவனத்தின் பெயர் காட்டப்படும்',
    consultancyName: 'ஆலோசனை பெயர்',
    otherThirdPartyname: 'பிற மூன்றாம் தரப்பு நிறுவனத்தின் பெயர்',
    jobDescriptionPlaceholder: 'பணியாளரின் பொறுப்புகள் என்ன?',
    officeLocationCityPlaceholder: 'நகரம்/டவுன் தேட',
    officeLocationAreaPlaceholder: 'இடம்/ஏரியா தேட',
    noOptionsDropdown: 'ஆப்சன்களுக்கு டைப் செய்யவும்',
    selectDistrict: 'மாவட்டத்தை தேர்ந்தெடுக்கவும்',
    selectDistricts: 'மாவட்டங்களைத் தேர்ந்தெடுக்கவும்',
    noDistrictSelected: 'தேர்ந்தெடுக்கப்பட்டிருக்கிறது',
    whatsappNumber: 'வாட்சப் நம்பர்',
    recruiterLogin: 'நீங்கள் வேலை வழங்கும் நிறுவனமாக லாகின் செய்திருக்கிறீர்கள்',
    advertiserTooltip: 'இந்த வேலையைப் பார்க்கும் நபர்களுக்கு இந்த பெயர் தான் வேலை வழங்கும் நிறுவனத்தின் பெயராக காட்டப்படும்',
    consultancyManpowerFirm: 'Consultancy / Manpower firm',
    thirdPartyHire: 'I hire for third party companies',
    companyNew: 'Company',
    companyStore: 'I hire for my company / store',
    consultancyNameNew: 'கன்சல்டன்சி பெயரை உள்ளிடவும்',
    choosePlan: 'பிளானைத் தேர்ந்தெடுக்கவும்',
    noFeeWarning: '   கட்டணம் எதுவும்  வசூலிக்கப்படவில்லை என்பதை உறுதிப்படுத்திக் கொள்ளவும். விண்ணப்பதாரர்களை ஏமாற்றும் விளம்பரதாரர்கள்/நிறுவனங்களை பிளாக் செய்யவும் அத்தகைய வேலை பதிவுகளை நீக்கவும் லோக்கல் ஆப்-க்கு முழு உரிமையும் இருக்கிறது.',
    feePaidQuestion: 'கட்டணத்தை எப்போது செலுத்த வேண்டும்? (கட்டாயமல்ல)',
    feePaidCaution: 'விண்ணப்பதாரர்களை ஏமாற்றும் விளம்பரதாரர்கள்/நிறுவனங்களை பிளாக் செய்யவும் அத்தகைய வேலை பதிவுகளை நீக்கவும் லோக்கல் ஆப்-க்கு முழு உரிமையும் இருக்கிறது.',
    useCurrentLocation: 'தற்போதைய இருப்பிடத்தைப் பயன்படுத்தவும்',
    skillsRequired: 'தேவையான திறன்',
    addOtherSkills: 'கூடுதல் திறன்களை சேர்க்க',
    additionalSkills: 'கூடுதல் திறன்கள்',
    additionalSkillsMsg: 'நீங்கள் அதிகபட்சம் 3 கூடுதல் திறன்களை சேர்க்கலாம்',
    additionalSkillsPlaceholder: 'கூடுதல் திறன்களை கமா பயன்படுத்தி சேர்க்கவும்',
    perDistrictChargeOne: 'நீங்கள் கட்டண திட்டத்தை வாங்கினால்',
    perDistrictChargeTwo: 'ஒவ்வொரு மாவட்டத்துக்கும்',
    perDistrictChargeThree: 'கட்டணம் செலுத்த வேண்டும்',
    skillsSelectedPlaceholder: 'தேர்ந்தெடுக்கப்பட்ட திறன்கள்',
    industryLocation: 'தொழிற்சாலை இருக்கும் இடம்',
    fieldLocation: 'கள இருப்பிடம்',
    workFromHome: 'பதிவு அலுவலக முகவரி',
    submit: 'சமர்ப்பிக்க',
    tncOne: 'முழு',
    tncTwo: 'விதிமுறைகளையும் நிபந்தனைகளையும்',
    tncThree: 'படிக்கவும்',
    courseTitle: 'Select Course/Certificate',
    minEducation: 'Minimum Education',
    selectCoursePlaceholder: 'Select Course Name',
    courseName: 'Course name',
    optional: 'optional',
    experience: 'Experience',
    postingLocationMessage: 'You will receive candidates from',
    postingLocationModalTitle: 'Select hiring location',
    postingLocationSearchPlaceHolder: 'Search cities',
    //commented till translations not provided
    // proceedToPaySubtext: 'We follow fair use and privacy rules. Breaking policies or fraud can lead to account suspension and loss of service fees.',
    // checkout: 'Checkout',
    // checkoutInfo: 'Review your order and proceed with payment to unlock your benefits.',
    // orderSummary: 'Order Summary'
  },
  postJobErrorStates: {
    noOptions: 'ஏதேனும் ஒரு ஆப்சனை தேர்ந்தெடுக்கவும்',
    wrongValue: 'சரியான மதிப்பை உள்ளிடவும்',
    noOpenings: 'பணியிட எண்ணிக்கையை உள்ளிடவும்',
    noMonthlySalary: 'மாத சம்பளத்தை உள்ளிடவும்',
    lowMinSalary: 'குறைந்தபட்ச சம்பளம் 1000க்கு குறைவாக இருக்கக்கூடாது',
    highMinSalary: 'குறைந்தபட்ச மாத சம்பளம் ரூ.1,00,000 க்கு கீழ் இருக்க வேண்டும்',
    noFeeAmount: 'கட்டணத் தொகையை உள்ளிடவும் (in ₹)',
    lowMaxSalary: 'அதிகபட்ச சம்பளம் 1000 க்கு கீழே இல்லாமல் இருக்க வேண்டும்',
    highMaxSalary: 'அதிகபட்ச சம்பளம் ரூ.1,00,000 க்கு கீழ் இருக்க வேண்டும்',
    minGreaterMax: 'அதிகபட்ச சம்பளம் குறைந்தபட்ச சம்பளத்தை விட அதிகமாக இருக்க வேண்டும்',
    noTextArea: 'டெக்ஸ்ட் பகுதியை நிரப்பவும்',
    noPhoneNumber: 'தொலைபேசி எண்ணை உள்ளிடவும்',
    noConsultancyName: 'கன்சல்டன்சி பெயரை உள்ளிடவும்',
    noCompanyName: 'நிறுவனத்தின் பெயரை உள்ளிடவும்',
    noCompanyType: 'நிறுவனத்தின் வகையை உள்ளிடவும்',
    noDataFound: 'No Data Found'
  }
}
